<template>
  <div style="height: 100%">
    <div class="add-user-orgin ubv">
      <div class="tip">
        <i class="icon icon-tishi"></i>
        <span>{{ $t('base_user_item_step_organ.ygkglckjrdbmzdsyjq') }}</span>
      </div>
      <div class="wrap ub-f1">
        <div class="search" style="height: 32px">
          <el-form>
            <el-form-item>
              <el-input :placeholder="$t('base_user_item_step_organ.bu_men_ming_cheng')" v-model="appKey" style="width: 100%" @input="filterTree" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="tree">
          <el-tree
            ref="tree"
            node-key="bizId"
            :data="organTree"
            :props="{ children: 'children', label: 'bizName' }"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            :check-strictly="true"
            :default-expanded-keys="expandedKeys"
            :filter-node-method="filterNode"
            default-expand-all
            highlight-current
          >
            <span class="tree-item" slot-scope="{ node, data }">
              <span>
                {{ node.label }}
                <i v-if="data.bizId === organData.bizId" @click="addDepartment(data)" class="el-icon-plus add-organ"></i>
              </span>
              <span>
                <el-checkbox v-model="node.checked">{{ $t('base_user_item_step_organ.jia_ru') }}</el-checkbox>
              </span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('base_user_item_step_organ.shang_yi_bu') }}</el-button>
      <el-button type="primary" @click="saveOrganUser">{{ $t('Common.com_save') }}</el-button>
    </div>
    <organ-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="successAddOrgan"></organ-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import organDialog from '@/pages/base/components/organDialog.vue';

export default {
  components: {
    organDialog,
  },
  props: {
    userId: [String, Number],
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},

      organData: {},
      organTree: [],
      appKey: '',
      expandedKeys: ['1'],
      orgId: '',
      userOrgId: '',
    };
  },
  mounted: function () {
    this.orgId = this.getJump('orgId');
    this.getOrganTree();
  },
  methods: {
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    onStep: function () {
      this.$emit('step', { name: 'organ' });
    },
    // 获取组织树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { orgId: this.orgId }).then((res) => {
        const obj = res.data || {};
        this.organTree = [obj];
        this.userOrgId = obj.orgId;
        this.getUserOrganList();
      });
    },
    // 获取用户组织列表(不分页)
    getUserOrganList: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(apis.UserDepartmentBindList, { userId: this.userId }).then((res) => {
        const checkedKeys = res.data;
        this.$refs.tree.setCheckedKeys(checkedKeys);
      });
    },
    // 选中部门
    handleNodeClick: function (data) {
      this.expandedKeys = [data.bizId];
      this.organData = data;
    },
    // 筛选组织
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.orgName.indexOf(value) !== -1;
    },
    // 搜索过滤事件
    filterTree: function (value) {
      this.expandedKeys = ['1'];
      this.$refs.tree.filter(value);
    },
    // 新增部门
    addDepartment: function (data) {
      this.dialogModel = data;
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_user_item_step_organ.xin_zeng_bu_men');
      this.dialogVisible = true;
    },
    // 保存新增部门
    successAddOrgan: function () {
      this.clearKeepAlive('department');
      this.getOrganTree();
    },
    // 保存用户部门
    saveOrganUser: function () {
      const selectDepartment = this.$refs.tree.getCheckedNodes();
      if (!selectDepartment.length) {
        this.$message.error(this.$t('base_user_item_step_organ.qzsxzygbm'));
        return;
      }
      const params = {
        userId: this.userId,
        orgDepartments: selectDepartment.map(t => ({
          bizId: t.bizId,
          bizType: t.bizType,
          bizPath: t.bizPath.split('/').slice(0, -1),
        })),
      };
      // const bizIds = selectDepartment.map(t => t.bizId);
      // const list = selectDepartment.filter(t => [...bizIds, ...t.bizPath.split('/').slice(0, -1)].length === [...new Set([...bizIds, ...t.bizPath.split('/').slice(0, -1)])].length);
      // const params2 = list.map(t => ({
      //   bizId: this.userId,
      //   bizType: 3,
      //   toBizId: t.bizId,
      //   toBizType: t.bizType,
      //   orgId: this.orgId || this.userOrgId,
      // }));
      this.$postJSON(apis.UserDepartmentBind, params).then(() => {
        this.onStep();
      });
      // Promise.all([this.$postJSON(apis.UserDepartmentBind, params), this.$postJSON(apis.organDeviceBindAutoAdd, params2)]).then(() => {
      //   this.onStep();
      // });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';
.add-user-orgin {
  height: 100%;
  .tip {
    background: rgba(254, 244, 219, 1);
    margin-bottom: 16px;
    padding-left: 10px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
  .wrap {
    border: 1px solid rgba(230, 235, 242, 1);
    padding: 16px;
    border-radius: 2px;
  }
  .add-organ {
    @include color_main();
    font-weight: bold;
    margin-left: 4px;
  }
  .tree {
    height: 600px;
    overflow-y: auto;
    .el-tree-node__content > .el-tree-node__expand-icon {
      color: #495057;
      &.is-leaf {
        color: transparent;
      }
    }
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .el-checkbox__label {
        font-size: 12px;
      }
    }
  }
}
</style>
